/** @jsxImportSource @emotion/react */

import { Typography } from "@a_team/ui-components";
import { AccountCollaboratorInviteModal } from "components/AccountCollaboratorInviteModal";
import CollaboratorsTable from "components/Collaborators/CollaboratorTable";
import { useGlobalModals } from "components/GlobalModals";
import TrackButton from "components/TrackButton";
import TrackModal from "components/TrackModal";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useRootStore } from "store";

export const CollaboratorManageModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => {
  const location = useLocation();
  const {
    missionSpecStore: { missionSpec },
  } = useRootStore();

  const { addModal, removeModal } = useGlobalModals();

  const inviteModal = useCallback(
    () => (
      <AccountCollaboratorInviteModal
        isOpen
        onClose={() => removeModal(inviteModal)}
        missionSpec={missionSpec}
      />
    ),
    [removeModal, missionSpec]
  );

  return (
    <>
      <TrackModal
        name="Manage Collaborators Modal"
        eventProps={{ path: location.pathname }}
        isOpen={isOpen}
        onClose={close}
        shouldCloseOnOverlayClick={true}
        zIndex={10001}
        styles={{
          width: "94%",
          maxWidth: 960,
        }}
      >
        <Typography variant="textLarge" component={"div"} weight="bold">
          Manage mission collaborators
        </Typography>
        <Typography variant="textMedium" component={"p"}>
          Invite new collaborators to your mission.
        </Typography>
        <div style={{ marginTop: 16 }}>
          <TrackButton
            name="Open Invite Collaborator Modal"
            onClick={() => addModal(inviteModal)}
            variant="main"
            size="md"
          >
            Invite collaborator
          </TrackButton>
        </div>
        <CollaboratorsTable closeCollaboratorManageModal={close} />
      </TrackModal>
    </>
  );
};
